'use client';

import Image from 'next/image';

import { cn } from '@/lib/utils';

interface BrandLoaderProps {
  /** ロゴの幅(px) */
  width?: number;
  /** 下部に表示するメッセージ */
  message?: string;
  /** メッセージの色クラス(背景に合わせて切替) */
  messageClassName?: string;
  className?: string;
}

/**
 * ブランドロゴ(logo.png)を表示し、ふわっと拡縮(breathe)させて
 * ローディングを表現する。(freee人事労務のようなロゴ主体のローダー)
 */
export function BrandLoader({
  width = 200,
  message,
  messageClassName = 'text-gray-500',
  className,
}: BrandLoaderProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Image
        src="/logo.png"
        alt="tes-navi"
        width={1032}
        height={243}
        priority
        className="animate-brand-breathe h-auto"
        style={{ width }}
      />
      {message && <p className={cn('text-sm font-medium', messageClassName)}>{message}</p>}
    </div>
  );
}
